// extracted by mini-css-extract-plugin
export default {"displayByIdTextField":"DisplayById_displayByIdTextField__biGJw","backButtonRow":"DisplayById_backButtonRow__s8MEJ","idPage":"DisplayById_idPage__jUnQJ"};